"use strict";

var _interopRequireDefault = require("E:/WebProject/\u684C\u9762/JY-SSO/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAdChannel = getAdChannel;
exports.getCatalogList = getCatalogList;
exports.getMenu = getMenu;
exports.getPackage = getPackage;
var _request = _interopRequireDefault(require("@/utils/request"));
function getAdChannel(params) {
  return (0, _request.default)({
    url: '/api/v1/adChannel',
    method: 'get',
    params: params
  });
}
function getPackage(params) {
  return (0, _request.default)({
    url: '/api/v1/package',
    method: 'get',
    params: params
  });
}
function getMenu(params) {
  return (0, _request.default)({
    url: '/api/v1/menu',
    method: 'get',
    params: params
  });
}

// 获取素材目录列表
function getCatalogList(params) {
  return (0, _request.default)({
    url: '/api/v1/local_material',
    method: 'get',
    params: params
  });
}